export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_odevquant.png",
      alt: "Nome da extensão",
    },
    title: "Estratégias Quantitativas Automatizadas para Potencializar seus Investimentos",
    text: [
      "Desde 2019, a ODevQuant desenvolve estratégias quantitativas avançadas para os mercados financeiros, utilizando algoritmos de Machine Learning, Inteligência Artificial e análise estatística para identificar oportunidades de forma totalmente automatizada. ",
      "Estudos de mercado mostram que apenas uma pequena parcela dos participantes consegue obter resultados consistentes no longo prazo, enquanto a maioria acaba sendo impactada por decisões emocionais, falta de disciplina ou ausência de metodologia. ",
      "Pensando nisso, nossos sistemas foram desenvolvidos para operar com regras objetivas, gestão de risco estruturada e execução totalmente automatizada, eliminando o fator emocional e aplicando rigor quantitativo às decisões de investimento. ",
      "Agora você pode replicar automaticamente essas estratégias em sua própria conta, acessando tecnologia quantitativa profissional e fazendo parte do grupo de investidores que utilizam dados, automação e inteligência quantitativa para buscar consistência no mercado.",
    ],
    testimonial: {
      text: "Inovação, disciplina quantitativa e gestão de risco são os pilares que sustentam estratégias consistentes no longo prazo.",
      author: {
        name: "Rafael Gonçalves, CEO ODevQuant",
        // picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  stats: {
    title: "ODevQuant em números",
    subtitle: "Tecnologia, dados e disciplina quantitativa aplicados a um mercado onde poucos conseguem consistência.",
    data: [
      {
        value: "150",
        description: "Algoritmos e estratégias em operação",
      },
      {
        value: "+15",
        description: "Etapas no processo de desenvolvimento. Pesquisa → modelagem → backtest → validação → execução. ",
      },
      {
        value: "92%",
        description: "Meses positivos registrados ",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs ODevQuant?",
    subtitle: "Veja quais as principais vantagens dos robôs da ODevQuant.",
    data: [
      {
        title: "100% Automatizado",
        description:
          "Invista com tecnologia profissional, sem complicação. \n\nVocê não precisa acompanhar gráficos ou tomar decisões complexas. Basta conectar sua conta e ativar as estratégias da ODevQuant — nossos algoritmos executam tudo automaticamente. ",
      },
      {
        title: "7 Dias para Testar",
        description:
          "Experimente antes de decidir. \n\nTeste nossas estratégias por 7 dias diretamente em sua conta e acompanhe como a tecnologia quantitativa opera em condições reais de mercado.",
      },
      {
        title: "Sem Emoção, Apenas Dados",
        description:
          "Decisões baseadas em matemática, não em sentimento. \n\nNossos algoritmos operam seguindo regras quantitativas rigorosas, eliminando decisões impulsivas e aplicando disciplina sistemática às operações.",
      },
      {
        title: "Diversificação Inteligente",
        description:
          "Múltiplos modelos operando simultaneamente. Diversificar entre diferentes estratégias quantitativas ajuda a reduzir risco e aumentar estabilidade. ",
      },
      {
        title: "Gestão de Risco Quantitativa",
        description:
          "O capital vem sempre em primeiro lugar. Cada estratégia é desenvolvida com modelos de controle de risco baseados em estatística e probabilidade. ",
      },
      {
        title: "Tecnologia de Ponta",
        description:
          "Inovação aplicada ao mercado financeiro. Na ODevQuant combinamos tecnologia avançada, ciência de dados e experiência de mercado para desenvolver soluções modernas de investimento. ",
      },
    ],
  },
  cta: {
    title: "Pronto para começar a operar com tecnologia quantitativa?",
    subtitle: "Ativar Estratégia Agora ",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "ODevQuant",
    col1: [
      "Fundada por um Engenheiro de Software e investidor inconformado com as limitações dos investimentos tradicionais, a ODevQuant nasceu com o objetivo de aplicar tecnologia e ciência de dados ao mercado financeiro. ",
      "Desde 2019, desenvolvemos estratégias quantitativas totalmente automatizadas, utilizando Machine Learning, Inteligência Artificial e modelagem estatística para identificar oportunidades e executar operações de forma sistemática. ",
      "Nosso foco está na construção de estratégias robustas, disciplinadas e orientadas por dados, capazes de operar em diferentes mercados e ativos com consistência e controle de risco.",
      "Na ODevQuant, acreditamos que o mercado financeiro deve ser tratado com rigor científico e responsabilidade. Respeitamos o capital de cada cliente e desenvolvemos nossas estratégias com processos rigorosos de validação, testes e monitoramento contínuo. ",
    ],
    col2: [
      "Para nós, gestão de risco não é baseada em opinião ou emoção, mas em matemática e probabilidade. Utilizamos modelos quantitativos avançados para estruturar e controlar o risco das estratégias, buscando preservar capital e manter estabilidade operacional.",
      "Outro princípio fundamental da ODevQuant é o alinhamento com nossos clientes. Operamos nossas próprias estratégias em contas reais, garantindo que nossos interesses estejam diretamente conectados aos resultados das estratégias.",
      "Acreditamos que transparência, disciplina e inovação tecnológica são os pilares para construir relações duradouras com nossos clientes e parceiros.",
      "Nosso compromisso é continuar evoluindo nossos modelos e tecnologias para oferecer soluções quantitativas modernas, eficientes e acessíveis a investidores que buscam uma abordagem mais profissional no mercado financeiro. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da ODevQuant",
  },
  strategies: {
    title: "Estratégias ODevQuant",
    heading: "Estratégias quantitativas robustas disponíveis para sua conta",
    subtitle:
      "Acesse estratégias desenvolvidas com Inteligência Artificial, análise estatística e automação completa, projetadas para operar com disciplina, gestão de risco e foco em consistência no longo prazo. ",
  },
  testimonials: [
    {
      text: "Iniciei minha jornada no mundo dos investimentos com as estratégias da ODevQuant e isso transformou minha vida. Como mãe de família e autônoma, encontrei a consistência e o sucesso que sempre busquei no mercado financeiro. As estratégias automatizadas me permitiram alcançar resultados excepcionais, garantindo mais segurança e estabilidade para minha família. Obrigada, Rafael e equipe, por todo o apoio e dedicação. ",
      author: "Rejiane Silva",
      job: "Autônoma e Mãe de Família",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "Após quebrar várias contas operando de forma desenfreada, finalmente encontrei a consistência e os lucros que buscava com as estratégias da ODevQuant. A abordagem automatizada e bem estruturada transformou minha maneira de investir, trazendo resultados positivos e estáveis. Sou grato a Rafael e sua equipe por me ajudarem a virar o jogo no mercado financeiro. ",
      author: "Guilherme Pires Gonçalves",
      job: "Analista de Sistemas",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
  ],
};
